const OperationTraceIdMap: {
	[operationName: string]: string[] | undefined;
} = {};

export const startCapturingTraceIds = (operationName: string): void => {
	OperationTraceIdMap[operationName] = OperationTraceIdMap[operationName] || [];
};
export const stopCapturingTraceIds = (operationName: string): void => {
	OperationTraceIdMap[operationName] = undefined;
};
export const addTraceId = (operationName: string, traceId?: string): void => {
	if (traceId !== undefined) {
		const traceIdsForOperation = OperationTraceIdMap[operationName];
		if (traceIdsForOperation !== undefined) {
			traceIdsForOperation.push(traceId);
		}
	}
};

export const getTraceIds = (operationName: string): string[] =>
	OperationTraceIdMap[operationName] || [];
